const NEW_ADDRESS_OPTION_ID = 'new-address';

function normalizedText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeShippingAddress(shippingAddress) {
  const id = normalizedText(shippingAddress?.id);
  const savedAddressId = id && id !== NEW_ADDRESS_OPTION_ID ? id : null;
  const normalized = {
    address: normalizedText(shippingAddress?.address),
    address2: normalizedText(shippingAddress?.address2) || null,
    city: normalizedText(shippingAddress?.city),
    country: normalizedText(shippingAddress?.country).toUpperCase(),
    postalCode: normalizedText(shippingAddress?.postalCode),
    region: normalizedText(shippingAddress?.region).toUpperCase(),
  };

  if (savedAddressId) {
    return { id: savedAddressId, ...normalized };
  }

  if (typeof shippingAddress?.isDefault === 'boolean') {
    return { ...normalized, isDefault: shippingAddress.isDefault };
  }

  return normalized;
}

export function normalizeCapability(value) {
  if (typeof value?.enabled !== 'boolean') {
    return null;
  }

  return {
    enabled: value.enabled,
    reason: typeof value.reason === 'string' ? value.reason : '',
  };
}

export function normalizeUserErrors(errorMessages) {
  if (!Array.isArray(errorMessages)) {
    return [];
  }

  return errorMessages.map((error) => ({
    code: typeof error?.code === 'string' ? error.code : null,
    message:
      typeof error?.message === 'string'
        ? error.message
        : 'Tax calculation is temporarily unavailable. Please try again.',
    path: typeof error?.path === 'string' ? error.path : 'calculateCartTax',
  }));
}

export function requestFailure(code = 'TAX_QUOTE_REQUEST_FAILED') {
  return [
    {
      code,
      message: 'Tax calculation is temporarily unavailable. Please try again.',
      path: 'calculateCartTax',
    },
  ];
}

export function capabilityFailure() {
  return [
    {
      code: 'TAX_CAPABILITY_REQUEST_FAILED',
      message:
        'Checkout availability could not be confirmed. Please try again.',
      path: 'taxCheckoutCapability',
    },
  ];
}

export function quoteIsUnexpired(expiresAt) {
  const expiresAtMilliseconds = Date.parse(expiresAt);
  return (
    Number.isFinite(expiresAtMilliseconds) && expiresAtMilliseconds > Date.now()
  );
}

export function commercialDependencyKey({
  cart,
  cartId,
  deliveryMethod,
  shippingAddress,
}) {
  const items = [...(cart?.cartItemsAttributes || [])]
    .map((item) => ({
      discountAmount: item.discountAmount ?? 0,
      discountId: item.discountId ?? null,
      id: item.id ?? null,
      patientId: item.patientId ?? null,
      price: item.price ?? 0,
      productId: item.productId ?? null,
      quantity: item.quantity ?? 0,
    }))
    .sort((left, right) => String(left.id).localeCompare(String(right.id)));

  return JSON.stringify({
    cartId: cartId ?? null,
    currency: cart?.currency ?? null,
    deliveryMethod: deliveryMethod ?? null,
    discountAmount: cart?.discountAmount ?? 0,
    discountId: cart?.discountId ?? null,
    items,
    shippingAddress,
  });
}
